<template>
    <div class="card h-100">
      <div class="card-header p-1">
        <div class="row">
          <div class="d-flex flex-row justify-content-between row-item align-items-center" >
            <div class="w-90 text-header">
              {{ headerContent }}
            </div>
            <div class="w-10">
              <div v-if="type == 'Low_Strain' || type == 'High_Strain'">
                <IconStrain :color="iconColor"/>
              </div>
              <div v-else-if="type == 'Low_Recovery'">
                <IconRecovery :color="iconColor"/>
              </div>
              <div v-else>
                <IconSleep :color="iconColor"/>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <div class="card-body card-body-allignment">
        <div class="row">
          <div v-for="user in users" :key="user.udid" class="col-12 mb-3 card-row" >
            <trend-item-row :user="user" :selected-date="selectedDate" />
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import TrendItemRow from "./TrendItemRow.vue";
import IconStrain from "@/shared/Controls/Icons/IconStrain.vue";
import IconSleep from "@/shared/Controls/Icons/IconSleep.vue";
import IconRecovery from "@/shared/Controls/Icons/IconRecovery.vue";


export default {
  name: "TrendsCard",
  components: {
    TrendItemRow,
    IconStrain,
    IconSleep,
    IconRecovery,
  },
  props: {
    headerContent: {
      type: String,
      default: "Lowest Strain Scores",
    },
    subHeader: {
      type: String,
      default: "Based on DNA and wellness data Lowest Strain Scores",
    },
    type: {
      type: String,
      required: true,
      default: "Sleep"
    },
    users: {
      type: Object,
      required: true,
    },
    selectedDate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSleep: this.type == 'Low_Sleep',
      isStrain: this.type == 'Low_Strain' || this.type == 'High_Strain',
      isRecovery: this.type == 'Low_Recovery',
      iconColor: 'black'
    };
  },
};
</script>

<style lang="scss" scoped>
.img-profile {
  &-container {
    position: relative;
  }
  &-text-container {
    position: absolute;
    right: 0;
    bottom: 1em;
  }
  &-text-bg {
    position: relative;
  }
  &-text {
    position: absolute;
    left: 48px;
    bottom: 0;
  }
}
.header {
  letter-spacing: 1px;
  font-weight: 900;
}
.text-header {
    text-align: left !important;
    padding-top: 0.4rem;
    padding-left: 0.5rem;
    font-weight: 500 !important;
}
.card-row {
    background-color: #35494b;
    border-radius: 0.5rem;
    font-size: 0.5rem;
    margin-bottom: 0.35rem !important;
    padding-top: 0.4rem !important;
    padding-bottom: 0.25rem !important;
}
.card-body-allignment {
    padding-bottom: 0.5rem !important;
    padding-top: 0.5rem !important;
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
}
.trend-item-div {
   padding: 0.5rem !important;
}

</style>
